import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Pager, { usePager } from "@/components/Pager";

const STATUS_COLORS = {
  pending_mentor: "border-amber-200 bg-amber-50 text-amber-700",
  accepted: "border-emerald-200 bg-emerald-50 text-emerald-700",
  rejected: "border-rose-200 bg-rose-50 text-rose-700",
};

export default function AdminMentorRequestsPage() {
  const [reqs, setReqs] = useState([]);
  const pager = usePager(reqs, 20);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/mentor-requests");
      setReqs(r.data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-mentor-requests-page">
      <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">MENTOR REQUEST LOG</div>
      <h1 className="font-serif text-3xl lg:text-4xl text-kb-ink mt-1">Mentor request <em className="italic text-kb-primary">history</em></h1>
      <p className="text-sm text-kb-ink-muted mt-2 max-w-2xl">
        Every request sent from admin to a mentor lives here. To assign mentors to a new approved idea, go to{" "}
        <Link to="/admin/pending-ideas" className="text-kb-primary font-medium">Pending Ideas</Link>.
      </p>

      {loading ? <div className="mt-8 kb-mono text-xs text-kb-ink-muted">Loading…</div> :
        reqs.length === 0 ? (
          <div className="mt-10 text-center py-16 border border-dashed border-slate-300 rounded-sm bg-white text-sm text-kb-ink-muted">No mentor requests yet.</div>
        ) : (
          <div className="mt-8 space-y-3">
            {pager.pageItems.map((r) => (
              <div key={r.id} className="kb-card p-5" data-testid={`admin-mreq-${r.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted">
                      {r.id} · {new Date(r.sent_at).toLocaleDateString()}
                      {r.decided_at && <> · decided {new Date(r.decided_at).toLocaleDateString()}</>}
                    </div>
                    <h3 className="font-serif text-lg text-kb-ink mt-1">{r.idea_title}</h3>
                    <div className="text-sm text-kb-ink-muted mt-1">
                      CLIENT: <span className="text-kb-ink font-medium">{r.client_name}</span> ·
                      MENTOR: <span className="text-kb-ink font-medium">{r.mentor_name}</span>
                    </div>
                    {r.admin_note && <p className="text-xs text-kb-ink-muted mt-2"><span className="kb-mono text-[10px] text-kb-ink-light mr-2">ADMIN:</span>{r.admin_note}</p>}
                    {r.mentor_note && <p className="text-xs text-kb-ink-muted mt-1"><span className="kb-mono text-[10px] text-kb-ink-light mr-2">MENTOR:</span>{r.mentor_note}</p>}
                  </div>
                  <span className={`kb-mono text-[10px] uppercase tracking-wider px-2 py-1 rounded-sm border ${STATUS_COLORS[r.status] || "border-slate-200"}`}>{r.status.replace(/_/g, " ")}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      <Pager {...pager} label="requests" testId="admin-mentor-reqs-pager" />
    </div>
  );
}